import { render, staticRenderFns } from "./List-Management.vue?vue&type=template&id=575f6596&scoped=true&"
import script from "./List-Management.vue?vue&type=script&lang=js&"
export * from "./List-Management.vue?vue&type=script&lang=js&"
import style0 from "./List-Management.vue?vue&type=style&index=0&id=575f6596&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "575f6596",
  null
  
)

export default component.exports